import { H3, H4, H6, P, Image } from 'AbstractElements';
import { Label, Col, Media, Row, Badge, Button, FormGroup, Input } from "reactstrap";
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import user1 from 'assets/images/user/1.jpg';
import Moment from 'react-moment';
import 'moment/locale/id';
import FormModal from 'Component/Common/Form/FormModal';
import SelectStatus from './Form/SelectStatusOrder';
import SelectTreatmentOrder from './Form/SelectTreatmentOrder';
import SelectRescheduleOrder from './Form/SelectRescheduleOrder';
import { resetSetupOrder, setSetupOrder } from 'Services/Features/Order/orderSlice';
import { addTreatment, changeStatus, reschedule, addNote } from 'Services/Features/Order/Utils/orderUtils';
import { toast } from 'react-toastify';  

const InfoUserOrder = ({ item }) => {
    const dispatch = useDispatch();
    const dataSetupOrder = useSelector(state => state.order.setupOrder);

    const getStatusColor = (status) => {
        switch (status) {
            case 'pending': return 'warning'; // Kuning
            case 'paid': return 'success'; // Hijau
            case 'on_process': return 'warning'
            case 'canceled': return 'danger'; // Merah
            case 'completed': return 'success'; // Biru
            default: return 'secondary'; // Abu-abu (default)
        }
    };

    const getPaymentColor = (method) => {
        return method === 'online' ? 'info' : 'dark';
    };

    // Fungsi untuk mengecek apakah jadwal sudah terlewat
    const isSchedulePassed = () => {
        const now = new Date();
        const scheduleDate = new Date(item.schedule_date);
        const [endHour, endMinute] = item.schedule_hour_end.split(':');
        
        // Set waktu selesai pada tanggal jadwal
        const scheduleEndDateTime = new Date(scheduleDate);
        scheduleEndDateTime.setHours(parseInt(endHour), parseInt(endMinute), 0, 0);
        
        // Return true jika waktu sekarang sudah melewati waktu selesai jadwal
        return now > scheduleEndDateTime;
    };

    const toggleModalStatus = () => {
        setModalStatus(!modalStatus)
    };
    const [modalStatus, setModalStatus] = useState(false);
    const handleSubmitStatus = (e) => {
        e.preventDefault();
        // handleSubmit logic here
        if (!dataSetupOrder.status) {
            toast.error('Pilih status reservasi terlebih dahulu');
            return;
        }
        dispatch(changeStatus({ id: item.id, data: dataSetupOrder }));
        toggleModalStatus();
    };
    const handleDiscardStatus = () => {
        dispatch(resetSetupOrder());
        // handleDiscard logic here
        toggleModalStatus();
    };
    
    const toggleModalNote = (item) => {
        if (item) {
            dispatch(setSetupOrder({ cs_notes: item }));
        }
        setModalNote(!modalNote)
    };
    const [modalNote, setModalNote] = useState(false);
    const handleChangeNote = (e) => {
        const { value } = e.target;
        dispatch(setSetupOrder({ cs_notes: value }));
    };
    const handleSubmitNote = (e) => {
        e.preventDefault();
        // handleSubmit logic here
        if (!dataSetupOrder.cs_notes) {
            toast.error('Tulis catatan reservasi terlebih dahulu');
            return;
        }
        dispatch(addNote({ id: item.id, data: dataSetupOrder }));
        toggleModalNote();
    };
    const handleDiscardNote = () => {
        dispatch(resetSetupOrder());
        // handleDiscard logic here
        toggleModalNote();
    };

    const toggleModalReschedule = (item) => {
        dispatch(setSetupOrder({ branch_id: item }));
        setModalReschedule(!modalReschedule)
    };
    const [modalReschedule, setModalReschedule] = useState(false);
    const handleSubmitReschedule = (e) => {
        e.preventDefault();
        console.log(dataSetupOrder);
        if (!dataSetupOrder.schedule_date || !dataSetupOrder.schedule_hour_start || !dataSetupOrder.schedule_hour_end) {
            toast.error('Pilih jadwal reservasi terlebih dahulu');
            return;
        }
        dispatch(reschedule({ id: item.id, data: dataSetupOrder }));
        toggleModalReschedule();
    };
    const handleDiscardReschedule = () => {
        dispatch(resetSetupOrder());
        // handleDiscard logic here
        toggleModalReschedule();
    };

    const toggleModalTreatment = (item) => {
        dispatch(setSetupOrder({ treatments: item }));
        setModalTreatment(!modalTreatment);
    };
    const [modalTreatment, setModalTreatment] = useState(false);
    const handleSubmitTreatment = (e) => {
        e.preventDefault();
        // handleSubmit logic here
        if (!dataSetupOrder.treatment_ids || dataSetupOrder.treatment_ids.length === 0) {
            toast.error('Pilih perawatan reservasi terlebih dahulu');
            return;
        }
        dispatch(addTreatment({ id: item.id, data: dataSetupOrder }));
        toggleModalTreatment();
    };
    const handleDiscardTreatment = () => {
        dispatch(resetSetupOrder());
        // handleDiscard logic here
        toggleModalTreatment();
    };
    
    
    return (
        <>
            <FormModal
                isOpen={modalTreatment}
                toggle={toggleModalTreatment}
                title={`Tambah Perawatan Reservasi #${item.id} - ${item.user?.name}`}
                handleSubmit={handleSubmitTreatment}
                handleDiscard={handleDiscardTreatment}
            >
                <SelectTreatmentOrder />
            </FormModal> 
            <FormModal
                isOpen={modalNote}
                toggle={toggleModalNote}
                title={`Tambah Catatan Reservasi #${item.id} - ${item.user?.name}`}
                handleSubmit={handleSubmitNote}
                handleDiscard={handleDiscardNote}
            >
                <FormGroup className='mb-3'>
                    <Input className="form-control" id="validationLocation" type="textarea" name="location" placeholder="Tulis catatan untuk reservasi ini..." required=""
                        value={dataSetupOrder.cs_notes || ""}
                        onChange={handleChangeNote} 
                        />
                </FormGroup>
            </FormModal>   
            <FormModal
                isOpen={modalReschedule}
                toggle={toggleModalReschedule}
                title={`Ubah Jadwal Reservasi #${item.id} - ${item.user?.name}`}
                handleSubmit={handleSubmitReschedule}
                handleDiscard={handleDiscardReschedule}
            >
                <SelectRescheduleOrder />
            </FormModal>  
            <FormModal
                isOpen={modalStatus}
                toggle={toggleModalStatus}
                title={`Ubah Status Reservasi #${item.id} - ${item.user?.name}`}
                handleSubmit={handleSubmitStatus}
                handleDiscard={handleDiscardStatus}
            >
                <SelectStatus />
            </FormModal>  
            <Row>
                <Col sm="6">
                    <Media>
                        <div className="media-left">
                            <Image attrImage={{ className: 'media-object img-60', src: `${item.user?.profile_pictures_path || user1}`, alt: 'User-Profile' }}
                            />
                        </div>
                        <Media body className="m-l-20">
                            <H4 attrH4={{ className: 'media-heading' }}>
                                <Label className="m-0">{item.user?.name || "-"}</Label>
                                {item.user?.verified_at && (
                                    <span style={{ color: 'green', marginLeft: '10px' }} title={`Verified at: ${item.user.verified_at}`}><i class="icofont icofont-check-circled"></i></span>
                                )}
                            </H4>
                            <P> {item.user?.email || "-"}
                                <br />
                                <span>{item.user?.phone || "-"}</span>
                            </P>
                        </Media>
                    </Media>
                </Col>
                <Col sm="6">
                    <div className="text-md-end text-xs-center">
                        <H3><Label className="m-0">{`Reservasi ${item.type} #`}<span className="counter">{item.id}</span></Label></H3>
                        <P>
                            Dibuat pada : <Moment format="DD MMMM YYYY, HH:mm:ss">{item.created_at}</Moment>
                            <br />
                            Tanggal Reservasi : <Moment format="DD MMMM YYYY">{item.schedule_date}</Moment> | Jam: {item.schedule_hour_start.slice(0, 5)} - {item.schedule_hour_end.slice(0, 5)}
                            <br />
                            Status: <Badge color={getStatusColor(item.status)}>
                                {item.status.replace(/_/g, ' ').charAt(0).toUpperCase() + item.status.replace(/_/g, ' ').slice(1)}
                            </Badge>
                            {' | '}
                            Pembayaran: <Badge color={getPaymentColor(item.payment_method)}>
                                {item.payment_method.charAt(0).toUpperCase() + item.payment_method.replace(/_/g, ' ').slice(1)}
                            </Badge>
                        </P>
                    </div>
                </Col>
                <Col sm="12" className="text-end mt-2">
                    <Button color="primary" className="btn btn-primary btn-sm mb-1 mx-1" onClick={() => { toggleModalNote(item.cs_notes) }}>
                        <i className="fa fa-book"></i> Catatan
                    </Button>
                    {!isSchedulePassed() && (
                        <>
                            <Button color="primary" className="btn btn-warning btn-sm mb-1 mx-1" onClick={() => { toggleModalStatus() }}>
                                <i className="fa fa-edit"></i> Ubah Status
                            </Button>
                            <Button color="success" className="btn btn-success btn-sm mb-1 mx-1" onClick={() => { toggleModalReschedule(item.branch_id) }}>
                                <i className="fa fa-refresh"></i> Reschedule
                            </Button>
                            {item.type === 'offline' && (
                                <Button color="info" className="btn btn-info btn-sm mb-1 mx-1" onClick={() => { toggleModalTreatment(item.treatment) }}>
                                    <i className="fa fa-plus"></i> Perawatan
                                </Button>
                            )}
                        </>
                    )}
                </Col>
            </Row>
            <hr />
            <Row className="invo-profile">
                <Col xl="8">
                    <div className="text-xl-start" id="project">
                        <H6><Label className="m-0">{`CABANG ${item.branch?.name}`}</Label></H6>
                        <P>{item.branch?.location}</P>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default InfoUserOrder;
